'use strict';

var _ = require('lodash');
var CompetitorFaresChartTransformationService = function CompetitorFaresChartTransformationService(configurationService) {
  var MAX_DTD = configurationService.getMaxDtd();
  var DTD_RANGE = _.range(MAX_DTD, -1);
  var hostAndSubsidiaryCarriers = configurationService.getHostAndSubsidiaryCarriers();
  function buildCompetitorId(competitorData) {
    return [competitorData.competitorCarrier, competitorData.departureDate, '[' + competitorData.competitorFlights.split(', ').join('|') + ']', competitorData.serviceId].join('.');
  }
  function isHostCarrier(carrier) {
    return _.includes(hostAndSubsidiaryCarriers, carrier);
  }
  function getCompetitorCarriers(curveData) {
    return _.chain(curveData).flatten().uniqBy('competitorCarrier').map(function (legendItem) {
      return {
        carrier: legendItem.competitorCarrier,
        isHostFare: isHostCarrier(legendItem.competitorCarrier)
      };
    }).sortBy(['isHostFare', 'carrier']).value();
  }
  function getCompFareCurve(curve) {
    var fareCurve = {};
    var prevValue = null;
    var departureTime;
    var curvePointFareAndTime;
    var value;
    _.map(DTD_RANGE, function (idx) {
      value = curve['D' + idx];
      value = _.isUndefined(value) ? prevValue : value;
      prevValue = value;
      if (!_.isNull(value)) {
        curvePointFareAndTime = value.split('@');
        departureTime = !_.isEmpty(curvePointFareAndTime[1]) ? curvePointFareAndTime[1] : departureTime;
        fareCurve[idx] = {
          dtd: idx,
          fare: parseFloat(curvePointFareAndTime[0]),
          departureTime: departureTime
        };
      } else {
        fareCurve[idx] = {
          dtd: idx
        };
      }
    });
    return {
      fareCurve: fareCurve,
      departureTime: departureTime
    };
  }
  function containsNotNullValue(item) {
    var curveOfCompetitorFareWithoutTooEarlyDTDsAndNulls = _.reduce(item.curveOfCompetitorFare, function (result, val, key) {
      if (val && +key.substring(1) <= MAX_DTD) {
        result.push(val);
      }
      return result;
    }, []);
    return !_.isEmpty(curveOfCompetitorFareWithoutTooEarlyDTDsAndNulls);
  }
  function filterDataAndPrepareCurve(curveData, selectedService) {
    return _.chain(curveData).filter(function (item) {
      return selectedService ? item.serviceId === selectedService : item.serviceId === 'UNMATCHED';
    }).filter(containsNotNullValue).transform(function (result, entry) {
      var fareCurveInfo = getCompFareCurve(entry.curveOfCompetitorFare);
      result.push({
        carrier: entry.competitorCarrier,
        departureDate: entry.departureDate,
        departureTime: fareCurveInfo.departureTime,
        fltNbrList: entry.competitorFlights,
        isHostFare: isHostCarrier(entry.competitorCarrier),
        nbrOfStops: entry.numberOfStops,
        serviceId: entry.serviceId,
        fareCurve: fareCurveInfo.fareCurve,
        entryKey: buildCompetitorId(entry)
      });
    }, []).value();
  }
  return {
    getCompetitorCarriers: getCompetitorCarriers,
    filterDataAndPrepareCurve: filterDataAndPrepareCurve
  };
};
CompetitorFaresChartTransformationService.$inject = ['ConfigurationService'];
module.exports = CompetitorFaresChartTransformationService;